import routes from '@/config/routes';
import { v3Get, v3Post, v3Put } from '../axios.instance.V3';
import { ApiResponse, ILxProfile, INewPasswordRequest } from '../types';

const updateCurrentClient = (clientId: number): ApiResponse<ILxProfile> => {
  return v3Post<ILxProfile>(routes.backendUrl.userProfile.setCurrentClient + clientId);
};

const updateMenuType = (menuTypeId: number): ApiResponse<ILxProfile> => {
  return v3Put<ILxProfile>(`${routes.backendUrl.userProfile.setMenuType}${menuTypeId}`);
};

const sendResetPasswordLink = (userName: string): ApiResponse => {
  return v3Get(`${routes.backendUrl.userProfile.sendResetPasswordLink}${userName}`);
};

const verifyResetLink = (token: string): ApiResponse => {
  return v3Get(`${routes.backendUrl.userProfile.verifyResetLink}${token}`);
};

const resetPassword = (data: INewPasswordRequest): ApiResponse => {
  return v3Post<ILxProfile>(routes.backendUrl.userProfile.resetPassword, data);
};

const getUpdatedProfile = (): ApiResponse => {
  return v3Get<ILxProfile>(routes.backendUrl.userProfile.getUpdatedProfile);
};

const login = (): ApiResponse => {
  return v3Get(routes.backendUrl.userProfile.login);
};

const getProfile = (): ApiResponse => {
  return v3Get(routes.backendUrl.userProfile.getProfile);
};

const checkUserIdentity = (): ApiResponse => {
  return v3Get(routes.backendUrl.userProfile.checkUserIdentity);
};

const logout = (): ApiResponse => {
  return v3Get(routes.backendUrl.userProfile.logout);
};

export const userProfileApi = {
  updateCurrentClient,
  updateMenuType,
  sendResetPasswordLink,
  verifyResetLink,
  resetPassword,
  getUpdatedProfile,
  login,
  getProfile,
  checkUserIdentity,
  logout,
};
